import _ from 'lodash'
import Gumshoe from 'gumshoejs'
import MENORQUINA_SCROLLSPY_CONFIG from './config'

class MenorquinaScrollspyClass {
    constructor() {
        this.DOM = {
            section: MENORQUINA_SCROLLSPY_CONFIG.section
        }

        this.gumshoe = null

        this.DOM.section ? this.init() : null
    }

    init() {
        this.gumshoe = new Gumshoe( '.c-section--menorquina-history .nav a', {
            offset: window.innerHeight / 2,
        })
    }
}

const MENORQUINA_SCROLLSPY = new MenorquinaScrollspyClass()
export default MENORQUINA_SCROLLSPY